import React, {useMemo} from 'react';
import css from "./index.module.less";
import {usePageContext} from "../../DownloadApp";
import {isRunInWeChat, openUrlInNewTab} from "../../utils";
import {getString} from "../../index";

function DownloadBlock(props) {
    const {currentPage, changeCurrentPage} = usePageContext();
    const {title, subTitle, downloadUrl, onClick} = props;

    const onDownloadButtonClick = () => {
        if (isRunInWeChat()) {
            changeCurrentPage("tutor");
        } else {
            openUrlInNewTab(downloadUrl);
        }
        onClick();
    };

    const isBaiduBoxApp = useMemo(() => {
        return navigator.userAgent.indexOf("Baidu") > -1;
    }, []);

    return (
        <div className={css.download_block_wrap} onClick={onDownloadButtonClick}>
            <img className={css.icon_size} src={require("../../images/picol.png")} alt="picol"/>

            <div className={css.desc_wrap}>
                <div className={css.main_title}>{title}</div>
                <div className={css.sub_title}>{subTitle}</div>
            </div>

            <div style={{display: "flex", justifyContent: "center", marginTop: 40}}>
                {isBaiduBoxApp
                    ? <img style={{height: 27, width: 90}} src={require("../../images/ic_download_btn.png")}
                           alt="pionex"/>
                    : <div className={css.download_button_wrap}>
                        {getString("download_button_text")}
                    </div>}
            </div>
        </div>
    );
}

export default DownloadBlock;
